import { render, staticRenderFns } from "./ConfirmEmail.vue?vue&type=template&id=7a8ef080&"
import script from "./ConfirmEmail.vue?vue&type=script&lang=ts&"
export * from "./ConfirmEmail.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmEmail.vue?vue&type=style&index=0&id=7a8ef080&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports